import { Component, inject, viewChild, effect, ChangeDetectionStrategy } from "@angular/core";
import { DatePipe } from "@angular/common";
import { MAT_DIALOG_DATA, MatDialogModule } from "@angular/material/dialog";
import { MatButtonModule } from "@angular/material/button";
import { MatPaginator, MatPaginatorModule } from "@angular/material/paginator";
import { MatSort, MatSortModule } from "@angular/material/sort";
import { MatTableDataSource, MatTableModule } from "@angular/material/table";
import { CampaignStatusDetails } from "src/app/models";

@Component({
    templateUrl: 'dialog-campaign-status-details.html',
    styleUrls: ['./dialog-campaign-status-details.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [DatePipe, MatDialogModule, MatButtonModule, MatTableModule, MatSortModule, MatPaginatorModule]
})

  export class DialogCampaignStatusDetails  {
    public displayedColumnsDetails: string[] = ['destination','avatarId','createDate', 'comment'];
    public data: any = inject(MAT_DIALOG_DATA);
    public campaignStatusDetails = new MatTableDataSource<CampaignStatusDetails>(this.data.result);
    sort = viewChild(MatSort);
    paginator = viewChild<MatPaginator>('paginator');

    constructor() {

      effect(() => {
        const sort = this.sort();
        if (sort) {
          this.campaignStatusDetails.sort = sort;
        }
      });

      effect(() => {
        const pager = this.paginator();
        if (pager) {
          this.campaignStatusDetails.paginator = pager;
          pager._intl.itemsPerPageLabel = "פריטים לעמוד";
          pager._intl.nextPageLabel = "הבא";
          pager._intl.previousPageLabel = "הקודם";
          pager._intl.changes.next();
        }
      });
    }


}
